import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';

const holidaySchedules =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'holiday-schedules', id]).compact().join('/');

    return {
      get: (query = {}, config) => get(url.concat(new QueryString(query).toString(true)), config),
      lookup: () => get(url.concat('/lookup')),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      clone: (body) => post(url.concat('/clone'), body),
      availableSchedules: (body) => post(url.concat('/available-schedules'), body),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      setDefaultStatus: (flag = true) => put(url.concat('/is-default'), { isDefault: flag }),
      delete: () => del(url),
    };
  };

export default holidaySchedules;
